<template>
	<div class="views">
		<button v-for="v in views" :key="v.key" class="vtab" :class="{ active: activeKey === v.key }" :title="v.help" @click="$emit('select', v)">
			{{ v.name }}<span v-if="v.count || v.count === 0" class="cpill">{{ v.count }}</span>
		</button>
		<span v-if="savedViews.length" class="vsep"></span>
		<button v-for="(v, i) in savedViews" :key="'s' + i" class="vtab saved" :class="{ active: activeKey === 'saved:' + i }" title="Saved view" @click="$emit('selectSaved', i)">
			<i class="fa-solid fa-star"></i> {{ v.label }}<i class="fa-solid fa-xmark del" @click.stop="$emit('deleteSaved', i)"></i>
		</button>
		<button v-if="canSave" class="vtab newv" title="Save the current filters, columns and sort as a reusable view" @click="$emit('new')"><i class="fa-solid fa-plus"></i> New view</button>
	</div>
</template>

<script>
export default {
	name: 'PeViews',
	props: {
		views: { type: Array, default: () => [] },
		savedViews: { type: Array, default: () => [] },
		activeKey: { type: [String, Number], default: '' },
		canSave: { type: Boolean, default: true }, // false hides New view
	},
}
</script>
